import { isly } from "isly";
export var Precision;
(function (Precision) {
    var _a;
    Precision.values = ["hours", "minutes", "seconds", "milliseconds"];
    _a = isly
        .string("value", ...Precision.values)
        .rename("isoly.Time.Minute.Numeric")
        .bind(), Precision.type = _a.type, Precision.is = _a.is, Precision.flawed = _a.flawed;
    Precision.factor = {
        hours: 3600000,
        minutes: 60000,
        seconds: 1000,
        milliseconds: 1,
    };
})(Precision || (Precision = {}));
//# sourceMappingURL=Precision.js.map